import {
  ScmIntegrationsApi,
  scmAuthApiRef,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  ApiRef,
  BackstageIdentityApi,
  configApiRef,
  createApiFactory,
  createApiRef,
  discoveryApiRef,
  githubAuthApiRef,
  oauthRequestApiRef,
  OAuthApi,
  ProfileInfoApi,
  SessionApi,
} from '@backstage/core-plugin-api';
import { GithubAuth } from '@backstage/core-app-api';

const GHE_HOST = 'github.austin.utexas.edu';
const EMU_HOST = 'github.com';

// GHE sign-in uses the built-in `githubAuthApiRef` (provider id `github`).
// EMU is a second GitHub provider (`github-emu`) with its own API.
export const githubEmuAuthApiRef: ApiRef<
  OAuthApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
> = createApiRef({
  id: 'internal.auth.github-emu',
});

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory({
    api: githubEmuAuthApiRef,
    deps: {
      configApi: configApiRef,
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
    },
    factory: ({ configApi, discoveryApi, oauthRequestApi }) =>
      GithubAuth.create({
        configApi,
        discoveryApi,
        oauthRequestApi,
        provider: {
          id: 'github-emu',
          title: 'GitHub EMU',
          icon: () => null,
        },
        environment: configApi.getOptionalString('auth.environment'),
        defaultScopes: ['read:user'],
      }),
  }),
  // Pick the user's token by SCM host, so scaffolder templates that request
  // user credentials get the GHE token for GHE repos and the EMU token for
  // github.com repos.
  createApiFactory({
    api: scmAuthApiRef,
    deps: {
      gheAuthApi: githubAuthApiRef,
      emuAuthApi: githubEmuAuthApiRef,
    },
    factory: ({ gheAuthApi, emuAuthApi }) =>
      ScmAuth.merge(
        ScmAuth.forGithub(gheAuthApi, { host: GHE_HOST }),
        ScmAuth.forGithub(emuAuthApi, { host: EMU_HOST }),
      ),
  }),
];
